module.exports = __webpack_public_path__ + "img/user_index_qrcode_bg.78c7062a.png";